var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.72084C17.3375 2.02199 16.6233 2.21989 15.8834 2.31453C16.6405 1.85851 17.2256 1.13576 17.501 0.26673C16.7868 0.696941 15.9952 0.998088 15.1606 1.17017C14.4809 0.430211 13.5258 0 12.4417 0C10.4197 0 8.76769 1.65201 8.76769 3.69121C8.76769 3.98375 8.8021 4.26769 8.86233 4.53442C5.79924 4.37954 3.0717 2.90822 1.25621 0.679732C0.937859 1.2218 0.75717 1.85851 0.75717 2.52964C0.75717 3.81166 1.40249 4.94742 2.40057 5.59274C1.78967 5.59274 1.2218 5.42065 0.722754 5.16253V5.18834C0.722754 6.97801 1.99618 8.47515 3.6826 8.81071C3.14116 8.95888 2.57274 8.9795 2.02199 8.87094C2.25568 9.60443 2.71337 10.2462 3.3307 10.7062C3.94804 11.1661 4.69398 11.421 5.46367 11.435C4.15896 12.4679 2.54168 13.0262 0.877629 13.0182C0.585086 13.0182 0.292543 13.001 0 12.9665C1.6348 14.0163 3.57935 14.6272 5.66157 14.6272C12.4417 14.6272 16.1673 9 16.1673 4.12142C16.1673 3.95794 16.1673 3.80306 16.1587 3.63958C16.8815 3.12333 17.501 2.46941 18 1.72084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.45f70ad74f7a2000e9b4face90595e20.svg";
export { ForwardRef as ReactComponent };